/**
 * Author: Francisco Edgardo Hernández Palacios.
 * File description: Component for route management.
 */

// Essential Imports
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Auth
import { AuthGuard } from './guards/auth.guard';

// Components
import { MainComponent } from './componentes/main.component';
import { LoginComponent } from './pantallas/login/login.component';
import { LoginGuard } from './guards/login.guard';
import { RifaComponent } from '../rifa/rifa.component';
import { RecoveryPassComponent } from './recoveryPass/recoveryPass.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    component: MainComponent,
    children: [
      { path: 'AmCham', loadChildren: '../catalogos/catalogos.module#CatalogosModule'},
      { path: 'AmChamAdmin', loadChildren: '../admin/admin.module#AdminModule', canActivate: [AuthGuard] },
    ]
  },
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'rifa', component: RifaComponent},
  { path: 'recoveryPass', component: RecoveryPassComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
